import { useCallback, useEffect, useState } from 'react';
import { FetchSoldProductsSearchProps, ListSoldSummary, SoldSummary } from 'lib/models/listSoldProducts';

function useSoldSummary(searchProps?: FetchSoldProductsSearchProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [summary, setSummary] = useState<SoldSummary>({
		totalOrders: 0,
		totalProductsSold: 0,
		totalPaid: 0,
		totalSaleFee: 0,
		totalSaleDiscount: 0,
		totalDelivered: 0,
		totalReturned: 0,
		totalDeliveredProducts: 0,
		totalReturnedProducts: 0,
		nfcCardOrders: 0,
		nfcCardProductsSold: 0,
		nfcCardTotalPaid: 0,
		nfcCardTotalSaleFee: 0,
		nfcCardTotalSaleDiscount: 0,
		nfcCardTotalDelivered: 0,
		nfcCardTotalReturned: 0,
		nfcCardDeliveredProducts: 0,
		nfcCardReturnedProducts: 0,
	});

	const refetch = useCallback(
		async (props?: FetchSoldProductsSearchProps) => {
			setLoading(true);
			const response = await ListSoldSummary(props || searchProps);
			setSummary(response);
			setLoading(false);
		},
		[searchProps]
	);

	useEffect(() => {
		refetch(searchProps);
	}, [refetch, searchProps]);

	return { loading, summary, refetch, setLoading };
}

export default useSoldSummary;
